module.exports = __webpack_public_path__ + "static/img/4_3_2.8f13a53f.jpg";